import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { updateUser } from "../api";
import type { IApiErrorResponse, IUpdateUserVariables } from "../types";

type IUpdateUserMutationResponse = Awaited<ReturnType<typeof updateUser>>;

interface IUpdateUserMutationVariables {
  lenderCompanyId: number;
  id: number;
  variables: IUpdateUserVariables;
}

export const useUpdateUserMutation = () => {
  return useMutation<
    IUpdateUserMutationResponse,
    AxiosError<IApiErrorResponse>,
    IUpdateUserMutationVariables
  >({
    mutationKey: mutationKeyMap.updateUser,
    mutationFn: async ({ lenderCompanyId, id, variables }) => {
      return await updateUser(lenderCompanyId, id, variables);
    },
  });
};
